import { UserRole } from "src/app/transports/user";
import { UserModel } from "src/app/types/UserModel";

export default function useProofreadGridActions(currentUser: UserModel) {
    const actions: ("edit" | "disable" | "viewText")[] = [];

    if (
        currentUser.role == UserRole.ROLE_ADMIN ||
        currentUser.role == UserRole.ROLE_PROJECT_MANAGER ||
        currentUser.role == UserRole.ROLE_LEAD_PROJECT_MANAGER ||
        currentUser.role == UserRole.ROLE_BUSINESS_MANAGER ||
        currentUser.role == UserRole.ROLE_LEAD_BUSINESS_MANAGER
    ) {
        actions.push("edit");
    }
    if (
        currentUser.role == UserRole.ROLE_ADMIN ||
        currentUser.role == UserRole.ROLE_PROJECT_MANAGER ||
        currentUser.role == UserRole.ROLE_LEAD_PROJECT_MANAGER ||
        currentUser.role == UserRole.ROLE_BUSINESS_MANAGER ||
        currentUser.role == UserRole.ROLE_LEAD_BUSINESS_MANAGER
    ) {
        actions.push("disable");
    }
    if (
        currentUser.role == UserRole.ROLE_ADMIN ||
        currentUser.role == UserRole.ROLE_LEAD_PROOFREADER ||
        currentUser.role == UserRole.ROLE_PROOFREADER ||
        currentUser.role == UserRole.ROLE_PROJECT_MANAGER ||
        currentUser.role == UserRole.ROLE_LEAD_PROJECT_MANAGER ||
        currentUser.role == UserRole.ROLE_BUSINESS_MANAGER ||
        currentUser.role == UserRole.ROLE_LEAD_BUSINESS_MANAGER ||
        currentUser.role == UserRole.ROLE_LINKER ||
        currentUser.role == UserRole.ROLE_LEAD_LINKER
    ) {
        actions.push("viewText");
    }
    return actions;
}
